/**
 * Verilen bir key'in belirli bir prefix ile başlayıp başlamadığını kontrol eder
 * @param {string} key - Kontrol edilecek key
 * @param {string} prefix - Aranan prefix
 * @returns {boolean} Key prefixle başlıyorsa true
 */
export const matchesPrefix = (key, prefix) => {
  return key === prefix || key.startsWith(`${prefix}:`)
}